// extracted by mini-css-extract-plugin
module.exports = {"membersDetail":"style_membersDetail__BCWAK","container":"style_container__PyNa9","title":"style_title__YGglB","scrollWrapper":"style_scrollWrapper__iyK5A"};